import { render, staticRenderFns } from "./IconArrowCircleUpOutline.vue?vue&type=template&id=61a47e4c"
import script from "./IconArrowCircleUpOutline.vue?vue&type=script&lang=js"
export * from "./IconArrowCircleUpOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports